import { makeAutoObservable } from "mobx";
import { SearchResultItem } from "core/models/search-result-item";

export const defaultNumberOfResultsToShow = 5;

export enum DisplayMode {
  All = "All",
  Dealers = "Dealers",
  Installers = "Installers"
}

class SearchStore {
  showNoResults = false;
  cities: string[] = [];
  filteredCities: string[] = [];
  filter = "";
  installers: SearchResultItem[] = [];
  dealers: SearchResultItem[] = [];
  country = "";
  city = "";
  isLoading = false;
  numberOfResultsToShow = defaultNumberOfResultsToShow;
  displayMode = DisplayMode.Installers;

  constructor() {
    makeAutoObservable(this);
  }

  get totalCount() {
    return this.dealers.length + this.installers.length;
  }

  updateIsLoading(value: boolean) {
    this.isLoading = value;
  }

  updateCountry(value: string) {
    this.country = value
  }

  updateCity(value: string) {
    this.city = value;
  }

  updateCities(value: string[]) {
    this.cities = value;
  }

  updateFilter(value: string) {
    this.filter = value;
  }

  updateFilteredCities(value: string[]) {
    this.filteredCities = value;
  }

  updateDealersAndInstallers(dealers: SearchResultItem[], installers: SearchResultItem[]) {
    this.dealers = dealers;
    this.installers = installers;
    this.showNoResults = dealers.length + installers.length == 0;
  }

  updateNumberOfResultsToShow(value: number) {
    this.numberOfResultsToShow = value;
  }

  updateDisplayMode(value: DisplayMode) {
    this.displayMode = value;
  }

  reset() {
    this.showNoResults = false;
    this.installers = [];
    this.dealers = [];
    this.filteredCities = [];
    this.filter = "";
    this.city = "";
    this.isLoading = false;
    this.numberOfResultsToShow = defaultNumberOfResultsToShow;
  }
}

export default SearchStore;
